module.exports = __webpack_public_path__ + "static/img/iconfont.8d4dd5b5.svg";